'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _SearchBar = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _search = require('redux/modules/search');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBarContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    search: state.search
  };
}, {
  addTag: _search.add,
  popTag: _search.pop,
  removeTag: _search.remove,
  getSuggestions: _search.getSuggestions
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(SearchBarContainer, _React$Component);

  function SearchBarContainer(props) {
    (0, _classCallCheck3.default)(this, SearchBarContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchBarContainer.__proto__ || (0, _getPrototypeOf2.default)(SearchBarContainer)).call(this, props));

    _this.handleTagAdd = _this.handleTagAdd.bind(_this);
    _this.handleTagPop = _this.handleTagPop.bind(_this);
    _this.handleTagRemove = _this.handleTagRemove.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SearchBarContainer, [{
    key: 'handleTagAdd',
    value: function handleTagAdd(tag) {
      var addTag = this.props.addTag;

      var isArchviz = this.props.pathname.indexOf('library/archviz') > -1;
      addTag(tag, isArchviz);
    }
  }, {
    key: 'handleTagPop',
    value: function handleTagPop() {
      var popTag = this.props.popTag;

      popTag();
    }
  }, {
    key: 'handleTagRemove',
    value: function handleTagRemove(tag) {
      var removeTag = this.props.removeTag;

      removeTag(tag);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      var getSuggestions = this.props.getSuggestions;

      getSuggestions(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$search = this.props.search,
          tags = _props$search.tags,
          suggestions = _props$search.suggestions;


      return _react2.default.createElement(_SearchBar2.default, {
        tags: tags,
        suggestions: suggestions,
        onTagAdd: this.handleTagAdd,
        onTagPop: this.handleTagPop,
        onTagRemove: this.handleTagRemove,
        onChange: this.handleChange
      });
    }
  }]);
  return SearchBarContainer;
}(_react2.default.Component)) || _class);
exports.default = SearchBarContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBar/SearchBar.jsx
// module id = 2755
// module chunks = 0